import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'

export default class PaymentsDataSource extends DataSourceBase {

  constructor(Vue, id) {
    super(Vue, id)
    
    Vue.$root.$on('unlicchanged', () => {
      this.refresh()
    })
  }

  // eslint-disable-next-line no-unused-vars
  callAction(actionName, params) {
    if (actionName == 'sendQ') {
      var result = JSON.stringify(this.getData().data)
      this.$store.commit('SET_PROCESSING', true)
      GraphqQlApi.callOperation({ operationId: 'saveConsumptionB' }, { result, isplan: false }).then(() => {
        this.$store.commit('SET_PROCESSING', false)
        this.$store.commit('SET_NOTIFY', { text: 'Показники надіслано!' })
      })
      return
    }
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {


    let unlic = this.getUnlic()
    if (!unlic) {
      this.$store.commit('SET_NOTIFY', { text: 'Оберіть особовий рахунок!' })
      return
    }

    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({ operationId: 'claimedConsumptionB' }, { unlic, isplan: false }).then(response => {
      this.$store.commit('SET_PROCESSING', false)
      var data = response.data.energyAccountQuery.counsumptionGroupBInfo

      data.data.forEach(counter => {

        counter.total = (+counter._quantityEndMonth - (+counter.quantityStartMonth)) * (+counter.koefTransformation) + (+counter._costs) - (+counter._costsSub)

        Object.defineProperty(counter, 'costs', {
          get() { return +this._costs },
          set(v) {
            this._costs = v
            this.total = (+this._quantityEndMonth - (+this.quantityStartMonth)) * (+this.koefTransformation) + (+this._costs) - (+this._costsSub)
          },
          enumerable: true
        })

        Object.defineProperty(counter, 'costsSub', {
          get() { return +this._costsSub },
          set(v) {
            this._costsSub = v
            this.total = (+this._quantityEndMonth - (+this.quantityStartMonth)) * (+this.koefTransformation) + (+this._costs) - (+this._costsSub)
          },
          enumerable: true
        })

        Object.defineProperty(counter, 'quantityEndMonth', {
          get() { return +this._quantityEndMonth },
          set(v) {
            this._quantityEndMonth = v
            this.total = (+this._quantityEndMonth - (+this.quantityStartMonth)) * (+this.koefTransformation) + (+this._costs) - (+this._costsSub)
          },
          enumerable: true
        })
      })
      this.$store.commit(`${this.getStoreModuleName()}/setData`, { ...data })
    })
  }
  getUnlic() {
    return this.$router.currentRoute.query.unlic
  }
}